import { useMutation } from '@tanstack/react-query';

import { FinancialPerformanceApi } from '../financialPerformance.api';

export const useGetPerformanceInvestment = () => {
  return useMutation({
    mutationFn: FinancialPerformanceApi.getCalculationsOfPerformanceInvestment,
  });
};
